// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const VariableIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="VariableIcon" ref={forwardedRef} {...props}>
      <path d="M2.396 13.948c.036 2.232 1.062 3.654 2.898 3.978l.288-.81c-1.17-.612-1.566-1.404-1.566-3.168v-1.476c0-1.368-.612-2.286-1.692-2.538 1.08-.252 1.692-1.17 1.692-2.538V5.92c0-1.764.396-2.556 1.566-3.168l-.288-.81C3.458 2.266 2.432 3.688 2.396 5.92L2.378 7.054c-.036 1.836-.81 2.16-1.728 2.16v1.44c.918 0 1.692.324 1.728 2.16z" />
      <path d="M15.79 13.948c0 1.764-.395 2.556-1.565 3.168l.288.81c1.836-.324 2.862-1.746 2.898-3.978l.018-1.134c.036-1.836.81-2.16 1.728-2.16v-1.44c-.918 0-1.692-.324-1.728-2.16L17.41 5.92c-.036-2.232-1.062-3.654-2.898-3.978l-.288.81c1.17.612 1.566 1.404 1.566 3.168v1.476c0 1.368.612 2.286 1.692 2.538-1.08.252-1.692 1.17-1.692 2.538z" />
      <path d="M9.362 15.478v.896h1.424V15.43c1.888-.256 3.024-1.376 3.024-3.088 0-1.664-1.12-2.672-3.184-3.088V6.182a6.2 6.2 0 0 1 2.272.8l.672-1.456a7.9 7.9 0 0 0-2.784-.864V3.67H9.362v.976C7.458 4.838 6.258 5.974 6.258 7.67c0 1.68 1.136 2.672 3.264 3.04v3.216a5.05 5.05 0 0 1-2.8-1.168L5.906 14.15c.896.736 2.144 1.216 3.456 1.328m.16-6.416c-1.056-.256-1.616-.72-1.616-1.488 0-.8.624-1.312 1.616-1.424zm2.64 3.344c0 .768-.608 1.296-1.536 1.472v-2.96c.96.24 1.536.736 1.536 1.488" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const VariableIcon = /* @__PURE__ */ Object.assign(
  VariableIconComponent,
  { displayName: 'VariableIcon' },
);
